<script>
  import { createEventDispatcher, getContext } from 'svelte'
  import { profileContextKey } from '../context'
  import { Buttons } from '../../elements'
  import { redeemVipCoupon, } from '../../api'
  import {
    ordersAwaitRefetch,
    loadingChange,
  } from '../store'
  import { handleDistance } from '../../helpers'

  export let activeMembershipQuery
  export let isLifetimeVip = false
  export let vipCode = ''
  export let userCountry

  let submitting = false
  let error = false

  const dispatch = createEventDispatcher()
  const userId = getContext(profileContextKey).getUserId()

  function formatDate(date) {
    const localeOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }
    return date.toLocaleDateString('en', localeOptions).replace(', ', ' ')
  }

  function nextYear(date) {
    date.setFullYear(date.getFullYear() + 1)
    return date
  }

  async function handleConfirm() {
    error = false
    try {
      submitting = true
      await redeemVipCoupon(userId, vipCode, isLifetimeVip)
      loadingChange.set(true)
      dispatch('completeVipRedemption')
      await activeMembershipQuery.startPolling(200)
      ordersAwaitRefetch.set(true)
      submitting = false
    } catch (e) {
      submitting = false
      error = true
    }
  }
</script>

<style>
  .title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 16px;
  }
  .sub-title {
    font-size: 16px;
    line-height: 22px;
  }
  hr {
    height: 1px;
    background-color: #dee0e2;
    border: none;
    margin: 24px 0;
  }
  .section {
    margin-bottom: 24px;
  }
  .para-title {
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    margin-bottom: 6px;
  }
  .para-main {
    font-size: 12px;
    line-height: 16px;
    color: #484c51;
  }
  .button {
    margin-top: 48px;
  }
  .error {
    font-size: 11px;
    line-height: 14px;
    color: #d83b41;
    margin-top: 12px;
    text-align: right;
  }
</style>

<p class="title">VIP</p>
<p class="sub-title">
  {#if isLifetimeVip}
    Lifetime
  {:else}
    1 Year Free at 3rd Gear
  {/if}
</p>
<hr />
<div class="section">
  <p class="para-main">This coupon code can be redeemed for the following benefit(s):</p>
</div>
<div class="section" data-test="vip-benefits">
  <p class="para-title">New Benefits: VIP</p>
  <p class="para-main">Includes 150 {handleDistance(userCountry)} of towing for all household vehicles</p>
</div>
<div class="section" data-test="vip-effective">
  <p class="para-title">Effective</p>
  <p class="para-main">
    {#if isLifetimeVip}
      This will be a lifetime membership.
    {:else}
      Membership will be effective for one year starting {formatDate(new Date())} through {formatDate(nextYear(new Date))}
    {/if}
  </p>
</div>

<div class="button">
  <Buttons
    confirm="Confirm to redeem"
    on:confirm={handleConfirm}
    on:cancel
    cancelDisabled={submitting}
    confirmDisabled={submitting}
  />
</div>

{#if error}
  <p class="error">Something wrong happens</p>
{/if}